<template>
	<div class="d-flex justify-space-between align-center">
		<span @click="updateValue(0)">0</span>
		<v-slider
			v-model="internalValue"
			show-ticks="always"
			xxxticks="{ 0: '0', 15: '15' }"
			:min="0"
			:max="15"
			:step="1"
			:color="color"
			track-color="primary"
			tick-size="2"
			dense
			:hide-details="true"
		/>
		<span @click="updateValue(15)">15</span>
	</div>
</template>

<script>
export default {
	name: 'ScoreSlider',
	emits: ['update:modelValue'],
	props: {
		modelValue: {
			type: Number,
			default: 7
		}
	},
	data() {
		return {
			internalValue: this.modelValue || 0
		}
	},
	watch: {
		modelValue: {
			immediate: true,
			handler(newVal) {
				const numVal = newVal !== undefined && newVal !== null ? newVal : 0
				if (this.internalValue !== numVal) {
					this.internalValue = numVal
				}
			}
		},
		internalValue(newVal, oldVal) {
			this.$emit('update:modelValue', newVal)
		}
	},
	methods: {
		updateValue(val) {
			// Vuetify 3 的 slider @input 事件直接传递数字值
			const numVal = typeof val === 'number' ? val : Number(val) || 0
			this.internalValue = numVal
			// Vue 3: 使用 update:modelValue
			this.$emit('update:modelValue', numVal)
		}
	},
	computed: {
		color() {
			const val = this.internalValue || 0
			if (val < 3) return 'indigo'
			if (val < 10) return 'teal'
			if (val < 15) return 'green'
			return 'red'
		}
	}
}
</script>
